import type { ReactNode } from "react";

interface FieldProps {
  label: string;
  required?: boolean;
  children: ReactNode;
}

export function Field({ label, required, children }: FieldProps) {
  return (
    <label className="flex flex-col gap-1.5 mb-3 [&>input]:appearance-none [&>input]:bg-paper [&>input]:border [&>input]:border-line [&>input]:rounded-[10px] [&>input]:px-3 [&>input]:py-[11px] [&>input]:font-sans [&>input]:text-base [&>input]:text-ink [&>input:focus]:outline-2 [&>input:focus]:outline-moss-2 [&>input:focus]:border-moss-2 [&>input:focus]:[outline-offset:1px]">
      <span className="text-xs uppercase tracking-[0.06em] text-ink-3 font-medium">
        {label}{required && <em className="not-italic text-terra ml-0.5">*</em>}
      </span>
      {children}
    </label>
  );
}
